export default [
  {
    imageSrc: "/images/step-forward-2025/speaker-claire-cohen.png",
    name: "Claire Cohen",
    jobTitle: "Award-Winning Journalist and Author",
  },
  {
    imageSrc: "/images/step-forward-2025/speaker-tiwalola-ogunlesi.png",
    name: "Tiwalola Ogunlesi",
    jobTitle: "Founder of Confident and Killing It",
  },
  {
    imageSrc: "/images/step-forward-2025/speaker-mitesh-sheth.png",
    name: "Mitesh Sheth FIA, MBE",
    jobTitle: "CIO, Newton Investment Management",
  },
  {
    imageSrc: "/images/step-forward-2025/speaker-georgia-harrison.png",
    name: "Georgia Harrison",
    jobTitle: "Journalist, Documentary Maker and Activist",
  },
  {
    imageSrc: "/images/step-forward-2025/speaker-kadeena-cox.png",
    name: "Kadeena Cox OBE",
    jobTitle: "Four Time Paralympic Champion",
  },
  {
    imageSrc: "/images/step-forward-2025/speaker-lisa-picardo.png",
    name: "Lisa Picardo",
    jobTitle: "Chief Business Officer of PensionBee UK",
  },
  {
    imageSrc: "/images/step-forward-2025/speaker-mimi-ikonn.png",
    name: "Mimi Ikonn",
    jobTitle: "Co-Founder of Intelligent Change",
  },
  {
    imageSrc: "/images/step-forward-2025/speaker-lamees-butt.png",
    name: "Lamees Butt",
    jobTitle: "Founder & CEO, Riser",
  },
  {
    imageSrc: "/images/step-forward-2025/speaker-eshita-kabra.png",
    name: "Eshita Kabra-Davies",
    jobTitle: "Founder & CEO, By Rotation",
  },
  {
    imageSrc: "/images/step-forward-2025/speaker-claire-isnard.png",
    name: "Claire Isnard",
    jobTitle: "Global Chief People & Organisation Officer, Chanel",
  },
  {
    imageSrc: "/images/step-forward-2025/speaker-lisa-conway-hughes.png",
    name: "Lisa Conway-Hughes",
    jobTitle: "Wealth Adviser and Founder",
  },
  {
    imageSrc: "/images/step-forward-2025/speaker-priya-ahluwalia.png",
    name: "Priya Ahluwalia",
    jobTitle: "Creative and Film Director",
  },
  {
    imageSrc: "/images/step-forward-2025/speaker-eve.png",
    name: "Eve",
    jobTitle:
      "GRAMMY, Daytime EMMY, BET and MTV Video Music Award Winning Icon",
  },
];
